export const RESERVE_STATE = {
    cancelled: "CANCELLED",
    rejected: "REJECTED",
    accepted: "ACCEPTED",
    pending: "PENDING",
    assisted: "ASSISTED",
    no_assisted: "NO-ASSISTED",
};

export const PLATFORMS = {
    ANDROID: "Android",
    IOS: "iOS",
    WEB: "web"
}